import { LogoutIcon } from 'static';
import styled from 'styled-components';
import { breakpoints } from 'theme';

export const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.color.aquaSqueeze};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  padding: 0 27px;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.pickledBluewood};
`;

export const Content = styled.div`
  background-color: white;
  height: calc(100% - 50px);
`;

export const ContentWrapper = styled.div`
  width: 50%;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  @media ${breakpoints.downXlg} {
    width: 60%;
  }
  @media ${breakpoints.downMdPlus} {
    width: 80%;
  }
  @media ${breakpoints.downSmPlus} {
    width: 100%;
    margin: 0;
    border-radius: 0;
  }
`;

export const StyledWrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.color.porcelain}`};
  padding: 0 25px;
  text-align: left;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  border-radius: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.color.blackSqueeze};
  }

  label {
    white-space: nowrap;
    font-size: 15px;
    color: ${({ theme }) => theme.color.pickledBluewood};
    margin-left: 14px;
    cursor: pointer;
    flex: 1;
  }

  input[type='radio'] {
    margin-right: 10px;
    cursor: pointer;
  }
`;

export const DeleteStyledWrapper = styled.div`
  border-radius: 8px;
`;

export const StyledLogoutIcon = styled(LogoutIcon)`
  width: 18px;
  height: 18px;

  path {
    fill: ${({ theme }) => theme.color.casper};
  }
`;

export const LogoutButton = styled.span`
  color: ${({ theme }) => theme.color.pickledBluewood};
  font-size: 15px;
  margin-left: 14px;
  font-weight: normal;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.color.pickledBluewood};
    opacity: 0.8;
  }
`;

export const StyledFloatingLoader = styled.div`
  position: fixed;
  width: 70px;
  height: 70px;
  right: 50px;
  top: 50px;
  background: #ffffffbf;
  border-radius: 50%;
  z-index: 100;
  box-shadow: 0px 0px 10px 0px #21cec9;
  display: flex;
  align-items: center;
  justify-content: center;
`;
